import * as d3 from 'd3-selection'
import draw from './draw'

const clipOffset = 10

function extension (selection, ganttId, xScale, y, height, tipHeight) {
  /*
   * Draw the extension path to show descendants with an extent exceeding this shape's extent.
   */
  selection.each(function () {
    var extension = d3.select(this)
                      .selectAll('path.gantt-item-descendant-extension-path')
                      .data(d => {
                        if (d._gantt.extendedDescendants) {
                          return [{
                            id: d.id,
                            x1: 0, // This wrapper always has the earliest start date.
                            x2: xScale(d._gantt.descendantsExtent[1]) - xScale(d._gantt.descendantsExtent[0]),
                            tipHeight: tipHeight
                          }]
                        } else {
                         return []
                        }
                      })

    extension.exit().remove()

    extension.enter()
             .insert('path', ':first-child') // Make sure this is always behind the real `path`s
               .attr('class', 'gantt-item-descendant-extension-path')
               .attr('id', d => `gantt-${ganttId}-item-descendant-extension-${d.id}`)
               .merge(extension)
               .call(draw, y, height)
  })
}

function item (selection, ganttId, y, height, tipHeight) {
  /* Add the path that draws the main shape. This is used 3 times in the svg:
   *  1. As a clip path on the vertical line endpoint, so the line is only visible within the drawing
   *  2. Used for the background shape
   *  3. Used for the foreground shape. This shape has a clip path rect to show its status
   */
  selection.each(function () {
    var item = d3.select(this)
                 .selectAll('path.gantt-item-task-path') // Main drawing path
                 .data(d => {
                   return [{
                     id: d.id,
                     hasChildren: d._gantt.hasChildren,
                     topRightRadius: (d._gantt.extendedDescendants && d._gantt.descendantsExtent[1] > d.endDate) ? 0 : undefined,
                     x1: d._gantt.x,
                     x2: d._gantt.width + d._gantt.x,
                     tipHeight: tipHeight,
                     rightTipOffset: d._gantt.rightOffset,
                     leftTipOffset: d._gantt.leftOffset
                   }]
                 })
    item.enter()
        .append('path')
        .attr('class', 'gantt-item-task-path')
        .merge(item)
        .attr('id', d => `gantt-${ganttId}-item-task-path-${d.id}`)
        .call(draw, y, height)

    item.exit().remove()
  })
}

export default function (selection, ganttId, xScale, y, height, tree, tipHeight) {
  selection.each(function () {
    var defs = d3.select(this)

    // Draw the paths used by the clip paths
    defs.call(extension, ganttId, xScale, y, height, tipHeight)
        .call(item, ganttId, y, height, tipHeight)

    // Extension clip path
    var extClip = defs.selectAll('clipPath.gantt-item-descendant-extension-clip-path')
                      .data(d => [d])
                      .enter()
                        .append('clipPath')
                          .attr('class', 'gantt-item-descendant-extension-clip-path')
                          .attr('id', d => `gantt-${ganttId}-item-descendant-extension-clip-path-${d.id}`)
                          .merge(defs.selectAll('clipPath.gantt-item-descendant-extension-clip-path'))

    extClip.selectAll('use')
           .data(d => [d])
           .enter()
           .append('use')
             .attr('xlink:href', d => `#gantt-${ganttId}-item-descendant-extension-${d.id}`)

    // A clip path around the shape. The shape has a larger stroke-width that it appears
    // See comments in the task drawing
    var shapeClip = defs.selectAll('clipPath.gantt-item-clip-path')
                        .data(d => [d])
                        .enter()
                          .append('clipPath')
                            .attr('class', 'gantt-item-clip-path')
                            .attr('id', d => `gantt-${ganttId}-item-clip-path-${d.id}`)
                            .merge(defs.selectAll('clipPath.gantt-item-clip-path'))

    shapeClip.selectAll('use')
             .data(d => [d])
             .enter()
             .append('use')
               .attr('xlink:href', d => `#gantt-${ganttId}-item-task-path-${d.id}`)

    var status = defs.selectAll('clipPath.gantt-item-status-clip-path')
                     .data(d => [d])
                     .enter()
                       .append('clipPath')
                       .attr('class', 'gantt-item-status-clip-path')
                       .attr('id', d => `gantt-${ganttId}-item-status-clip-path-${d.id}`)
                       .merge(defs.selectAll('clipPath.gantt-item-status-clip-path'))

    status.selectAll('rect')
          .data(d => [d])
          .enter().append('rect')
          .merge(status.selectAll('rect'))
          .attr('x', d => d._gantt.x - clipOffset)
          .attr('y', 0)
          .attr('height', tree.options.height)
          .attr('width', d => d._gantt.foregroundWidth + clipOffset)

    var verticalClip = defs.selectAll('clipPath.gantt-item-vertical-clip-path')
                           .data(d => [d])
                           .enter()
                             .append('clipPath')
                             .attr('class', 'gantt-item-vertical-clip-path')
                             .attr('id', d => `gantt-${ganttId}-item-vertical-clip-path-${d.id}`)
                             .merge(defs.selectAll('clipPath.gantt-item-vertical-clip-path'))

    verticalClip.selectAll('use')
                .data(d => [d])
                .enter().append('use')
                .merge(verticalClip.selectAll('use'))
                .attr('xlink:href', d => `#gantt-${ganttId}-item-task-path-${d.id}`)
  })
}
